/**
 * Cartões do wizard de criação de pedido.
 * - WizardSection: etapa ativa (card em destaque com título).
 * - DoneCard: etapa concluída — resumo compacto em linhas + botão Editar.
 */

export const WizardSection = ({ title, children }) => (
    <section className="mb-4 rounded-xl border border-primary bg-mgs-surface p-4 text-left shadow-lg">
        <h2 className="mb-3 border-b border-primary/30 pb-2 text-lg font-semibold text-laranjinha">{title}</h2>
        {children}
    </section>
);

export const DoneCard = ({ title, rows = [], onEdit, children }) => (
    <section className="mb-3 rounded-xl border border-primary/25 bg-mgs-surface/60 px-4 py-3 text-left">
        <div className="flex items-center justify-between gap-3">
            <h3 className="flex items-center gap-2 text-sm font-semibold text-laranjinha/80">
                <span aria-hidden="true" className="text-green-500">✓</span>
                {title}
            </h3>
            {onEdit ? (
                <button
                    type="button"
                    onClick={onEdit}
                    className="text-xs text-laranjinha/60 underline hover:text-primary"
                >
                    Editar
                </button>
            ) : null}
        </div>
        {rows.length ? (
            <dl className="mt-1 flex flex-wrap gap-x-6 gap-y-0.5">
                {rows.filter(row => row && row.value !== undefined && row.value !== null && row.value !== "").map((row) => (
                    <div key={row.label} className="flex gap-1 text-sm">
                        <dt className="text-laranjinha/50">{row.label}:</dt>
                        <dd className="text-laranjinha/90">{row.value}</dd>
                    </div>
                ))}
            </dl>
        ) : null}
        {children}
    </section>
);
